export const products = [
  {
    id: 1,
    name: "지오 지올라이트 120g",
    subtitle: "ZEO ZEOLITE · 120g",
    description: "크로아티아 천연 클리놉틸로라이트 지올라이트 100% 원료. 처음 시작하거나 여행 시 간편하게 사용할 수 있는 소용량 제품입니다.",
    price: "32,000",
    unit: "120g",
    image: "https://public.readdy.ai/ai/img_res/edited_614783e696f122873c1c161e832159b4_66dac949.jpg",
    badge: "입문용",
    benefits: ["과일과 채소 세척 (농약 및 중금속 흡착)", "디톡스 페이스 마스크", "바디 스크럽", "천연 데오도란트", "디톡스 배스"]
  },
  {
    id: 2,
    name: "지오 지올라이트 350g",
    subtitle: "ZEO ZEOLITE · 350g",
    description: "가장 많이 찾는 베스트셀러 용량. 꾸준한 일상 케어와 다양한 활용을 위한 최적의 사이즈로, 한 달 이상 풍부하게 사용 가능합니다.",
    price: "52,000",
    unit: "350g",
    image: "https://public.readdy.ai/ai/img_res/edited_05aa0e787f5a08c598bf6ce9f0c231b3_f85da126.jpg",
    badge: "베스트셀러",
    benefits: ["과일과 채소 세척 (농약 및 중금속 흡착)", "디톡스 페이스 마스크", "바디 스크럽", "천연 데오도란트", "디톡스 배스"]
  },
  {
    id: 3,
    name: "지오 지올라이트 1,000g",
    subtitle: "ZEO ZEOLITE · 1,000g",
    description: "가족 모두가 함께 오래 사용하거나 다양한 용도로 넉넉히 활용하고 싶은 분들을 위한 대용량 제품입니다.",
    price: "76,000",
    unit: "1,000g",
    image: "https://public.readdy.ai/ai/img_res/edited_05aa0e787f5a08c598bf6ce9f0c231b3_7757619d.jpg",
    badge: "대용량",
    benefits: ["과일과 채소 세척 (농약 및 중금속 흡착)", "디톡스 페이스 마스크", "바디 스크럽", "천연 데오도란트", "디톡스 배스"]
  }
];

export const features = [
  {
    id: 1,
    icon: "ri-percent-line",
    title: "100% 천연 지올라이트.",
    description: "크로아티아 청정 지역에서 채취한 순수 천연 클리놉틸로라이트 지올라이트만을 사용합니다."
  },
  {
    id: 2,
    icon: "ri-check-double-line",
    title: "과학적으로 검증됨.",
    description: "독립 기관의 엄격한 임상 연구를 통해 안전성과 효과가 과학적으로 입증된 성분입니다."
  },
  {
    id: 3,
    icon: "ri-record-circle-line",
    title: "순도 테스트 완료.",
    description: "국내외 영양 전문의와 웰니스 전문가들이 적극 추천하는 프리미엄 건강 솔루션입니다."
  },
  {
    id: 4,
    icon: "ri-arrow-up-circle-line",
    title: "활성화 입자.",
    description: "자연을 훼손하지 않는 지속가능한 채굴 방식과 친환경 제조 공정을 엄격하게 준수합니다."
  },
  {
    id: 5,
    icon: "ri-medal-2-fill",
    title: "다기능 미네랄.",
    description: "나노 다공성 구조가 체내 중금속, 유해물질을 흡착하여 자연스럽게 배출을 돕습니다."
  }
];

export const reviews = [
  {
    id: 1,
    name: "김민정",
    age: "40대",
    title: "3개월 복용 후 삶이 달라졌어요",
    content: "처음엔 반신반의했는데, 3개월 꾸준히 먹으니 피로감이 확연히 줄었고 피부도 많이 맑아졌어요. 주변에 적극 추천하고 있습니다.",
    rating: 5,
    product: "위딘 퓨어 파우더",
    date: "2025.12"
  },
  {
    id: 2,
    name: "박성호",
    age: "50대",
    title: "검진 수치가 좋아졌습니다",
    content: "건강검진에서 걱정되는 수치가 있었는데 위딘 캡슐을 꾸준히 복용하고 나서 수치가 정상 범위로 돌아왔어요. 정말 놀랍습니다.",
    rating: 5,
    product: "위딘 젤라이트 캡슐",
    date: "2025.11"
  },
  {
    id: 3,
    name: "이수연",
    age: "30대",
    title: "피부 트러블이 사라졌어요",
    content: "오랫동안 피부 트러블로 고생했는데 웰니스 키트를 한 달 사용하고 피부가 정말 투명해졌어요. 포장도 너무 고급스럽고 선물로도 좋아요.",
    rating: 5,
    product: "위딘 웰니스 키트",
    date: "2025.10"
  },
  {
    id: 4,
    name: "최원준",
    age: "40대",
    title: "소화가 훨씬 편해졌어요",
    content: "소화 문제로 오랫동안 불편했는데, 위딘 파우더 복용 후 속이 편해지고 배변이 규칙적이 됐습니다. 신뢰할 수 있는 제품이에요.",
    rating: 5,
    product: "위딘 퓨어 파우더",
    date: "2025.09"
  },
  {
    id: 5,
    name: "정유진",
    age: "30대",
    title: "활력이 넘쳐요!",
    content: "아침에 일어나는 게 힘들었는데 이제는 상쾌하게 일어날 수 있어요. 에너지 레벨이 확실히 올라간 걸 느낍니다. 강력 추천!",
    rating: 5,
    product: "위딘 젤라이트 캡슐",
    date: "2025.08"
  },
  {
    id: 6,
    name: "강다은",
    age: "20대",
    title: "선물받고 완전 팬이 됐어요",
    content: "엄마가 사줘서 반강제로 먹기 시작했는데... 2주 만에 컨디션 차이를 느꼈어요. 이제 제가 더 열심히 먹고 있어요 하하.",
    rating: 5,
    product: "위딘 웰니스 키트",
    date: "2025.07"
  }
];

export const certifications = [
  { id: 1, name: "EU 유기농 인증", icon: "ri-award-line" },
  { id: 2, name: "ISO 9001:2015", icon: "ri-medal-line" },
  { id: 3, name: "HACCP 인증", icon: "ri-shield-check-line" },
  { id: 4, name: "GMP 인증", icon: "ri-verified-badge-line" }
];

export const purchaseTiers = [
  {
    id: 1,
    name: "지오 지올라이트 120g",
    subtitle: "ZEO ZEOLITE · 입문용",
    price: "32,000",
    unit: "120g",
    description: "처음 시작하거나 여행 시 간편하게 사용할 수 있는 소용량 제품입니다.",
    features: ["약 2~3주 사용량", "소용량으로 간편한 휴대", "모든 활용법 가능", "무료 사용 가이드 제공"],
    highlight: false,
    cta: "구매하기"
  },
  {
    id: 2,
    name: "지오 지올라이트 350g",
    subtitle: "ZEO ZEOLITE · 베스트셀러",
    price: "52,000",
    unit: "350g",
    description: "가장 많이 찾는 베스트셀러 용량. 꾸준한 일상 케어와 다양한 활용을 위한 최적의 사이즈입니다.",
    features: ["약 1~2개월 사용량", "일상 디톡스 루틴 최적", "다목적 활용에 적합", "무료 사용 가이드 제공"],
    highlight: true,
    cta: "구매하기"
  },
  {
    id: 3,
    name: "지오 지올라이트 1,000g",
    subtitle: "ZEO ZEOLITE · 대용량",
    price: "76,000",
    unit: "1,000g",
    description: "가족 모두가 함께 오래 사용하거나 다양한 용도로 넉넉히 활용하고 싶은 분들을 위한 대용량입니다.",
    features: ["약 3~4개월 사용량", "가족 함께 사용 가능", "대용량 절약 구성", "무료 사용 가이드 제공"],
    highlight: false,
    cta: "구매하기"
  }
];

export const usageMethods = [
  {
    category: "Food Detox",
    icon: "ri-leaf-line",
    color: "#6B8C5E",
    bgColor: "#F0F5EE",
    items: [
      {
        title: "과일·채소·견과류 세척",
        steps: [
          "물을 담은 용기에 물 1L당 ZEO ZEOLITE 파우더 2스푼을 넣어주세요.",
          "과일이나 채소를 20분 정도 담근 후",
          "흐르는 물로 깨끗하게 헹구면 됩니다."
        ]
      },
      {
        title: "쌀 세척",
        steps: [
          "물을 담은 용기에 물 1L당 ZEO ZEOLITE 파우더 2스푼을 넣어주세요.",
          "쌀을 약 30분 담근 후",
          "깨끗하게 헹군 뒤 조리합니다."
        ]
      }
    ]
  },
  {
    category: "Beauty",
    icon: "ri-sparkling-2-line",
    color: "#8B7355",
    bgColor: "#F5F0E8",
    items: [
      {
        title: "Face Detox Mask",
        steps: [
          "지올라이트와 물을 3:1 비율로 섞어 페이스트를 만들어주세요.",
          "얼굴에 고르게 바른 후 약 15분 후 세안합니다."
        ]
      },
      {
        title: "Body Scrub",
        steps: [
          "코코넛 오일(또는 원하는 오일), 설탕, 지올라이트를 1:1 비율로 섞어 스크럽을 만듭니다.",
          "젖은 피부에 원을 그리며 마사지해주세요.",
          "1~2분 뒤 미지근한 물로 씻어냅니다."
        ]
      },
      {
        title: "Natural Deodorant",
        steps: [
          "깨끗하고 건조한 겨드랑이에 파우더를 소량 직접 사용할 수 있습니다.",
          "또는 코코넛 오일이나 물과 섞어 샤워 15분 전에 바르면 체취 제거에 도움을 줄 수 있습니다."
        ]
      }
    ]
  },
  {
    category: "Wellness",
    icon: "ri-water-flash-line",
    color: "#5B7B8A",
    bgColor: "#EDF3F5",
    items: [
      {
        title: "Detox Bath",
        steps: [
          "욕조에 1/4컵 ~ 1/2컵 정도의 지올라이트 파우더를 넣어주세요.",
          "20~30분 정도 몸을 담그면 피부를 통해 독소와 불순물 흡착을 돕습니다.",
          "목욕 후 깨끗한 물로 가볍게 헹궈주면 됩니다."
        ]
      }
    ]
  }
];
